import React from "react";
import { Box, Chip } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * TimingEventSubNav — sous-navigation directe entre les pages d'un même
 * event (Participants / Liste de départ / Chrono), ajoutée le 21.09.2026
 * pour éviter de repasser par le hub /timingsoftware à chaque fois.
 *
 * Conserve `?run=` dans l'URL au passage d'une page à l'autre quand il
 * est présent (utile en particulier entre Chrono et Liste de départ, qui
 * gèrent tous les deux une notion de manche — voir timingStartlist.js,
 * resolveRunNumber) — Participants n'a pas de notion de manche, mais
 * garder le paramètre ne le gêne pas.
 *
 * @param {string} eventKey
 * @param {"athletes"|"startlist"|"chrono"} current - onglet actif
 */
const TABS = [
    { key: "athletes", label: "Participants", path: "athletes" },
    { key: "startlist", label: "Liste de départ", path: "startlist" },
    { key: "chrono", label: "Chrono", path: "chrono" },
];

export default function TimingEventSubNav({ eventKey, current }) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const run = searchParams.get("run");
    const runSuffix = run ? `?run=${encodeURIComponent(run)}` : "";

    return (
        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }} className="no-print">
            {TABS.map((t) => (
                <Chip
                    key={t.key}
                    label={t.label}
                    clickable
                    color={current === t.key ? "primary" : "default"}
                    variant={current === t.key ? "filled" : "outlined"}
                    onClick={() => navigate(`/timingsoftware/${t.path}/${encodeURIComponent(eventKey)}${runSuffix}`)}
                />
            ))}
        </Box>
    );
}